import React from "react";

import { InfoSmIcon as InfoSm } from "@packages/ds";
import { useIntl } from "react-intl";

import { APP_NAME } from "Constants/documentationUrls";
import { Button, IconControl } from "ds/Button";
import Dialog from "ds/Dialog";

const MergeRadioDialog = ({ radioOption }: { radioOption: string }) => {
  const intl = useIntl();

  const defaultDialog = (
    <Dialog
      analyticId="modal.resource.default.dialog.description"
      title={intl.formatMessage({
        id: "modal.resource.default.dialog.title",
        defaultMessage: "Default resource sizes"
      })}
      description={intl.formatMessage(
        {
          id: "modal.resource.default.dialog.description"
        },
        {
          appName: APP_NAME
        }
      )}
      link={
        <Button
          analyticId="learnmore"
          href={intl.formatMessage({
            id: "links.manage.resources.init"
          })}
          variant="link"
        >
          {intl.formatMessage({ id: "learnmore" })}
        </Button>
      }
      trigger={
        <IconControl>
          <InfoSm />
        </IconControl>
      }
    />
  );
  const minimumDialog = (
    <Dialog
      analyticId="modal.resource.minimum.dialog.description"
      title={intl.formatMessage({
        id: "modal.resource.minimum.dialog.title",
        defaultMessage: "Minimum resource sizes"
      })}
      description={intl.formatMessage(
        {
          id: "modal.resource.minimum.dialog.description"
        },
        {
          appName: APP_NAME
        }
      )}
      link={
        <Button
          analyticId="learnmore"
          href={intl.formatMessage({
            id: "links.manage.resources.init.min.resources"
          })}
          variant="link"
        >
          {intl.formatMessage({ id: "learnmore" })}
        </Button>
      }
      trigger={
        <IconControl>
          <InfoSm />
        </IconControl>
      }
    />
  );
  const manualDialog = (
    <Dialog
      align="end"
      side="top"
      title={intl.formatMessage({
        id: "modal.resource.manual.dialog.title",
        defaultMessage: "Manually configure resources"
      })}
      description={intl.formatMessage({
        id: "modal.resource.manual.dialog.description",
        defaultMessage:
          "Please note that the deployment will fail, which is normal, as it allows you to configure your resources manually without deploying the merge right away. You can configure resources via the CLI or through the console."
      })}
      analyticId="modal.resource.manual.dialog.description"
      link={
        <Button
          analyticId="learnmore"
          href={intl.formatMessage({
            id: "links.manage.resources.adjust.resources"
          })}
          variant="link"
        >
          {intl.formatMessage({ id: "learnmore" })}
        </Button>
      }
      trigger={
        <IconControl>
          <InfoSm />
        </IconControl>
      }
    />
  );

  const dialogForRadioBtn = {
    child: () => null,
    default: () => defaultDialog,
    minimum: () => minimumDialog,
    manual: () => manualDialog
  };

  return dialogForRadioBtn[radioOption]();
};

export default MergeRadioDialog;
